const Router = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  REPORT: '/report',
  DEVELOPERS: '/developers',
};

export default Router;
